import request from '@/utils/request'

export function getboards(data) {
  return request({
    url: 'get/devices',
    method: 'post',
    params: data
  })
}
//{"board_id":"xxxx", "coins":"xxx", "downmsg":"raw json if needed"}
export function testCoins(data) {
  return request({
    url: 'test/device/downmsg',
    method: 'post',
    params: data
  })
}

export function pushDeviceFotaUpgrade(data) {
  return request({
    url: 'push/device/fota',
    method: 'post',
    params: data
  })
}

export function pushDeviceFotaUrlUpgrade(data) {
  return request({
    url: 'push/device/fota/url',
    method: 'post',
    params: data
  })
}

export function getDeviceUartConfig(data) {
  return request({
    url: 'device/uart/config/get',
    method: 'post',
    params: data
  })
}

export function setDeviceUartConfig(data) {
  return request({
    url: 'device/uart/config/set',
    method: 'post',
    params: data
  })
}

export function rebootDevice(data) {
  return request({
    url: 'dev/reboot',
    method: 'post',
    params: data
  })
}

// Phase 4: Device Management APIs
export function getDeviceProducts(data) {
  return request({
    url: 'dev/products',
    method: 'post',
    params: data
  })
}

export function getSubDevices(data) {
  return request({
    url: 'dev/sub/list',
    method: 'post',
    params: data
  })
}

export function getSubDeviceFaults(data) {
  return request({
    url: 'dev/sub/faults',
    method: 'post',
    params: data
  })
}

export function checkDeviceTestStatus(data) {
  return request({
    url: 'dev/test/status',
    method: 'post',
    params: data
  })
}

export function deviceTestCommand(data) {
  return request({
    url: 'dev/test/command',
    method: 'post',
    params: data
  })
}

export function deviceTestConfig(data) {
  return request({
    url: 'dev/test/config',
    method: 'post',
    params: data
  })
}

export function getVendingCommodities(data) {
  return request({
    url: 'dev/vending/commodities',
    method: 'post',
    params: data
  })
}

export function getVendingChallengeStats(data) {
  return request({
    url: 'dev/vending/challenge/stats',
    method: 'post',
    params: data
  })
}

// T06/T17: 设备远程开关机
export function powerCtrlDevice(data) {
  return request({
    url: 'dev/power/ctrl',
    method: 'post',
    params: data
  })
}

// T07/T18: 设备绑定历史查询
export function getDeviceBindHistory(data) {
  return request({
    url: 'dev/bind-history',
    method: 'post',
    params: data
  })
}
